import FinishGoodQualityInspectionNg from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspectionNg';

export default class FinishGoodQualityInspectionNgFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.finishGoodQualityInspectionId  = '';
		this.finishGoodQualityInspectionControlCard = '';
		this.problemCategoryId  = '';
		this.problemCategoryCode = '';
		this.qtyNg = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			finishGoodQualityInspectionId : '0',
			finishGoodQualityInspectionControlCard : '0',
			problemCategoryId : '0',
			problemCategoryCode : '0',
			qtyNg : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}